/* requires:
polyfill.js
*/

document
  .getElementById('nav')
  .querySelector('ul')
  .insertAdjacentHTML(
    'beforebegin',
    "<button id='menutoggle' aria-label='Menu' role='button'><div class='hamburger-box'><div class='hamburger-inner'></div></div><span>Menu</span></button>"
  );

const menuToggle = document.getElementById('menutoggle');
const sideNav = document.getElementById('sideNav');
const overlay = document.getElementById('overlay');
const activeClass = 'is-active';
const hiddenClass = 'invisible';

// Initialize sidenav state
if (sideNav) {
  sideNav.classList.add(hiddenClass);
}

function openMenu() {
  menuToggle.classList.toggle(activeClass);
  if (sideNav) {
    sideNav.classList.add('visible');
    sideNav.classList.remove(hiddenClass);
    sideNav.classList.toggle(activeClass);
  }
  if (overlay) {
    overlay.classList.toggle(activeClass);
  }
}

menuToggle.onclick = function (event) {
  openMenu();
  event.preventDefault();
};

// Handle sidenav submenu toggles
for (let submenu of document.querySelectorAll('#sideNav span.submenu')) {
  submenu.addEventListener('click', function () {
    const subMenu = submenu.nextElementSibling;
    if (subMenu) {
      submenu.classList.toggle(activeClass);
      subMenu.classList.toggle(activeClass);
    }
  });
}

for (let secondarySubmenu of document.querySelectorAll('#sideNav ul.submenu span.submenu.level-2')) {
  secondarySubmenu.addEventListener('click', function () {
    const subMenu = secondarySubmenu.nextElementSibling;
    if (subMenu) {
      secondarySubmenu.classList.toggle(activeClass);
      subMenu.classList.toggle(activeClass);
    }
  });
}

// Handle desktop nav submenu toggles
for (let submenuToggle of document.querySelectorAll('#nav .has-fullscreen-dropdown .submenu')) {
  const parentLi = submenuToggle.closest('li');
  const content = parentLi.querySelector('.fullscreen-dropdown');

  // Add hover listeners
  parentLi.addEventListener('mouseenter', () => {
    submenuToggle.classList.add(activeClass);
    if (content) content.classList.add(activeClass);
  });

  parentLi.addEventListener('mouseleave', () => {
    submenuToggle.classList.remove(activeClass);
    if (content) content.classList.remove(activeClass);
  });
}

function hideMenu() {
  // Handle sidenav and overlay
  if (sideNav) {
    sideNav.classList.remove(activeClass);
    setTimeout(() => {
      sideNav.classList.add(hiddenClass);
    }, 300);
  }
  if (overlay) {
    overlay.classList.remove(activeClass);
  }

  // Hide all menus
  const menus = document.querySelectorAll('#sideNav span.submenu, #nav .submenu, .fullscreen-dropdown');
  menus.forEach((menu) => {
    menu.classList.remove(activeClass);
  });

  menuToggle.classList.remove(activeClass);
}

// Close button functionality
document.getElementById('closebtn')?.addEventListener('click', function () {
  hideMenu();
});

// Handle outside clicks
document.addEventListener(
  'click',
  function (e) {
    const targetEl = e.target;
    if (!targetEl.closest('#nav') && !targetEl.closest('#sideNav')) {
      if (menuToggle.classList.contains(activeClass)) {
        hideMenu();
      }
    }
  },
  false
);

// Handle window resizing
let resizeTimer;
window.addEventListener(
  'resize',
  function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (menuToggle.offsetWidth <= 0 && menuToggle.offsetHeight <= 0) {
        hideMenu();
        if (sideNav && !sideNav.classList.contains(hiddenClass)) {
          sideNav.classList.add(hiddenClass);
        }
      }
    }, 250);
  },
  false
);
